import React, { useCallback, useEffect, useState } from "react";
import { Card, Pagination, Button, ConfigProvider, Input } from "antd";
import { useHistory } from "react-router-dom";
import "./index.scss";
import zh_CN from "antd/es/locale/zh_CN";
import Collected from "images/collected.png";
import CollectWork from "images/collectWork.png";
import {getcodeValue } from "@/utils/storage"
export default function JobItem(props) {
  
  const {
    job: {
      job, //职位名称
      workArea,//工作地区
      placeOfWorkType, //工作地区
      auditMechanismName, //公司名称
      resumeOrNot, //是否投递简历
      recruitsNumber, //招聘人数
      salary, //薪资
      workExperience, //工作年限
      degree, //学历
      auditMechanismScale, //企业人数
      welfare, //福利待遇
      favoriteOrNot, //是否收藏
      id,
      type,
      
    },
    collect,
    handleJobDetail,
  } = props;
  
  
  return (
    <div className={"job_item_boxs"}>
      <section
        onClick={() => {
          handleJobDetail(id);
        }}
        className={"job_item_header"}
      >
        <div className={"job_item_title"}>
          <div className={"job_item_left"}>
            <span className={"job_item_name"}>{job}</span>
            <span className={"job_item_area"}>
              {/* 「{placeOfWorkType ? "其他" : "眉山"}」 */}
              「{workArea}」
            </span>
            <span
              className={"job_item_delivery"}
              style={
                job
                  ? { background: "rgba(51, 86, 197, 0.16)", color: "#3356C5" }
                  : {
                      background: "#3356C5",
                      boxShadow: "0px 2px 4px 0px rgba(9, 34, 114, 0.24)",
                      color: "#fff",
                      cursor: "pointer",
                    }
              }
            >
              {resumeOrNot ? "已投递" : "投递简历"}
            </span>
          </div>
          <div>
            <span className={"job_item_company_name"}>
              {auditMechanismName}
            </span>
          </div>
        </div>
        <div className={"job_item_info"}>
          <div className={"job_item_left"}>
            <span className={"job_item_salary"}>{salary}</span>
            <span className={"job_item_work_year"}>{workExperience}</span>
            <span className={"job_item_split"}>|</span>
            <span className={"job_item_education"}>{getcodeValue('edu_lev_code',degree)}</span>
          </div>
          <div>
            <span className={"job_item_recruitment_num"}>
              招聘人数：{recruitsNumber}
            </span>
            {/* <span className={"job_item_enterprise_type"}>
              {type ? type : ""}
            </span> */}
            <span className={"job_item_enterprise_num"}>
            公司规模：{auditMechanismScale}
            </span>
          </div>
        </div>
      </section>
      <section className={"job_item_footer"}>
        <div className={"job_item_left"}>
          <span className={"job_item_treatment"}>{welfare}</span>
        </div>
        {collect?<div className={"job_item_collection"}>
          <img
            src={favoriteOrNot == 1 ? Collected : CollectWork}
            alt=""
            style={{ marginBottom: 6 }}
          />
          <span onClick={() => {collect(id,favoriteOrNot)}} style={{ marginLeft: 6 }}>
            {favoriteOrNot == 1 ? "已收藏" : "收藏职位"}
          </span>
        </div>:''}
      </section>
    </div>
  );
}
